import { createSelector } from 'reselect';

import { keyBy } from 'helpers/lodashReplacement';

const getBrandList = state => state.brandList;
const getSupportedBrands = state => state.supportedBrands;

export const getBrands = createSelector(
  [getBrandList, getSupportedBrands],
  (brandList, supportedBrands) => {
    if (brandList.length && supportedBrands.length) {
      const brandListById = keyBy(brandList, 'id');
      return supportedBrands
        .map(({ brandId }) => {
          const brand = brandListById[brandId];
          if (brand) {
            return { name: brand.name, id: brandId };
          }
        })
        .filter(Boolean);
    } else {
      return [];
    }
  }
);
